import { styled } from 'styled-components';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import { colors, fontWeights } from 'theme/theme';

export const CmsReactionsProfileInfoCardHolder = styled.div`
  display: flex;
  gap: 35px;
`;

export const CmsReactionsProfileInfoCardLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 128px;
  flex-shrink: 0;
`;

export const CmsReactionsProfileInfoCardNameLink = styled(
  StyledVersionedRouterLink,
)`
  color: ${colors.mediumContentGrey};
  margin-top: 8px;
  font-weight: ${fontWeights.semiBold};
  font-size: 16px;
  text-align: center;
  text-decoration: none;
`;

export const CmsReactionsProfileInfoCardLocation = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 2px;
  max-width: 100%;
`;

export const CmsReactionsProfileInfoCardLocationText = styled.span`
  font-size: 16px;
  flex: 1;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const CmsReactionsProfileInfoCardSummary = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 30px;
  flex: 1;
`;
